var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"offline",class:{ active: _vm.$store.getters.offlineBanner }},[_vm._v(" You are currently offline ")]),_c('RouterView',{attrs:{"name":"notFoundView"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }